import "./HomePage.scss";
import React from "react";
import GradientContainer from "../../components/GradientContainer/GradientContainer";
import Services from "../../components/Services/Services";
import ContactMeButton from "../../components/ContactMeButton/ContactMeButton";
import ContactMe from "../../components/ContactMe/ContactMe";
import PortfolioGrid from "../../components/PortfolioGrid/PortfolioGrid";
import FullWidthImage from "../../components/FullWidthImage/FullWidthImage";
import showcaseImg from "../../assets/images/trade-show-booth-design.webp";


export default function HomePage() {
  return (
    <div className="home-page">
    <GradientContainer>
  <div className="home-page__hero-container">
    <div className="home-page__hero-container__heading">
      <h1>Design you can rely on</h1>
      <h4>
        I help marketing managers and business owners deliver impactful design and marketing solutions that drive results.
      </h4>
    </div>
    <div className="home-page__hero-container__project-button">
      <ContactMeButton 
        label="Let’s start your project"
        href="/contact"
        variant="default" 
      />
    </div>
  </div>
</GradientContainer>

      <PortfolioGrid />
      <Services />
      <FullWidthImage src={showcaseImg} alt="Showcase of Lindsay's design work at a trade show booth" />
      <ContactMe />

     </div>
  );
}
